import React, { FC, useEffect, useState } from 'react';
import styles from './Cards.module.scss';
import { ICard } from 'interfaces/card';
import Card from 'components/shared/cards/card/Card';
import Button from 'components/shared/button/Button';
import ReactPaginate from 'react-paginate';
import { Pagination } from 'interfaces';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import Loader from 'components/common/loader/Loader';
import { getParams } from 'utils/http.utils';

interface ICards {
  cards: ICard[];
  isLoading: boolean;
  button?: {
    text: string;
    onClick: () => void;
  } | null;
  pagination?: Pagination;
}

export const Cards: FC<ICards> = ({ cards, button, pagination, isLoading }) => {
  const itemsPerPage = 12;
  const [pageCount, setPageCount] = useState(pagination?.total || 0);
  const [itemOffset, setItemOffset] = useState(pagination?.page || 0);
  const [currentItems, setCurrentItems] = useState(cards);

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentItems(cards);
    setPageCount(pagination?.total ? Math.ceil(pagination?.total / itemsPerPage) : 0);
  }, [cards, pagination]);

  const handlePageClick = (event: any) => {
    const page = event.selected + 1;
    const params = getParams();

    if (page !== pagination?.page) {
      setSearchParams({ ...params, page });
      navigate(
        {
          search: createSearchParams({ ...params, page }).toString(),
        },
        { replace: true }
      );
    }
  };

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(cards.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(cards.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  return (
    <>
      {isLoading ? (
        <div className="flexWrapper flexWrapper--center">
          <Loader />
        </div>
      ) : (
        <>
          <div className={styles.cardsWrapper}>
            {currentItems.map((card: ICard, i: number) => (
              <Card
                key={i}
                type={card.type}
                description={card.description}
                imageUrl={card.imageUrl}
                rating={card.rating}
                title={card.title}
                link={card.link}
                reviewLabel={card.reviewLabel || ''}
                showLearnMoreBtn={card.showLearnMoreBtn}
                onDelete={card.onDelete}
                onView={card.onView}
              />
            ))}
            {((currentItems.length > 3 && currentItems.length % 2 !== 0) ||
              currentItems.length === 2) && <div style={{ flexGrow: 0.87 }} />}
          </div>
          {button && <Button text={button.text} onClick={button.onClick} />}
          {pagination && (
            <ReactPaginate
              nextLabel=""
              className="pagination"
              pageClassName="page"
              onPageChange={handlePageClick}
              pageRangeDisplayed={0}
              marginPagesDisplayed={2}
              initialPage={pagination?.page - 1 || 0}
              pageCount={pageCount}
              previousLabel=""
            />
          )}
        </>
      )}
    </>
  );
};

export default Cards;
